$(".accordion__btn").on("click", function () {
  if ($(this).hasClass("collapsed")) {
    $(".accordion__btn").html(
      $("html")[0].lang == "pl" ? "Czytaj więcej" : "Read more"
    );
    $(this).html($("html")[0].lang == "pl" ? "Zamknij" : "Close");
  } else {
    $(this).html($("html")[0].lang == "pl" ? "Czytaj więcej" : "Read more");
  }
});
